import {axiosFormDataInstance, axiosInstance} from "./axiosConfig";



export const setSetting = async (key,value) => {
    return axiosInstance.post('/settings/set', {key,value});
};

export const getSettings = async (id) => {
    return axiosInstance.get('/settings/get');
};

export const addSimContractImage = async (image) => {
    return axiosInstance.post('/settings/add-sim-contract-image', {image});
};

export const getAllCountries = async (page=1, perPage=10, search='') => {
    let url = '/geo/countries?page='+page+'&per_page='+perPage;
    if(search !== ''){
        url = url+'&search='+search;
    }
    return axiosInstance.get(url);
};

export const getAllCities = async (countryId, page=1, per_page=10, search='') => {
    let url = '/geo/country/' + countryId + '/cities?page=' + page + '&per_page=' + per_page;
    if (search !== '') {
        url = url + '&search=' + search;
    }
    return axiosInstance.get(url);
}

export const getAllStates = async (cityId, page=1, per_page=10, search='') => {
    let url = '/geo/city/' + cityId + '/states?page=' + page + '&per_page=' + per_page;
    if (search !== '') {
        url = url + '&search=' + search;
    }
    return axiosInstance.get(url);
}

export const getAllCountryStates = async (countryId) => {
    let url = '/geo/all-country-states/' + countryId;
    return axiosInstance.get(url);
}



export const addCountryData = async (country, city, states) => {
    return axiosInstance.post('/geo/add-country-data', {country, city, states});
};

export const addCityData = async (country, city, states) => {
    return axiosInstance.post('/geo/add-city-data', {country, city, states});
};


export const deleteCountry = async (id) => {
    return axiosInstance.delete('/geo/country/' + id);
};
export const deleteCity = async (id) => {
    return axiosInstance.delete('/geo/city/' + id);
};
export const deleteState = async (id) => {
    return axiosInstance.delete('/geo/state/' + id);
};

export const viewCountry = async (id) => {
    return axiosInstance.get('/geo/country/' + id);
};


export const refreshSimsSupervisors = async () => {
    return axiosInstance.post('/settings/refresh-sims-supervisors');
}